const breadcrumbsStyle = () => ({
  breadcrumbs: {
    paddingTop: 5,
  },
});

export default breadcrumbsStyle;
